module.exports = require('./DashboardPage');